import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge37 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の減損・評価損の判定基準' fontWeight={700} />
                <p>
                    評価損の具体的な計上方法や貸倒処理のケース分けについては
                    <a href='/knowledge/10'>評価損の計上方法</a>
                    で詳しくご紹介していますが、本記事ではその前段として「そもそもどのような状況になったら評価損（減損）を検討すべきか」という判定基準を、会計上・税務上それぞれの視点から整理します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='会計上の判定基準：時価の有無で考え方が変わる' fontWeight={700} />
                <p>
                    会計上、ゴルフ会員権は投資その他の資産として貸借対照表に計上されます。評価減を検討するかどうかは、まず時価（取引相場）があるかどうかで考え方が分かれます。
                </p>

                <Heading3 title='取引相場があるゴルフ会員権' />
                <p>
                    市場で取引相場が形成されている会員権は、期末時点の時価が帳簿価額を著しく下回り、かつ近い将来に回復する見込みがないと認められる場合に、時価まで評価減し、評価損として計上します。
                </p>

                <Heading3 title='取引相場のないゴルフ会員権（預託金形態）' />
                <p>
                    取引相場のない預託金形態の会員権は、発行会社（ゴルフ場運営会社）の財政状態の悪化にともなって、預託金の回収可能性を含めた実質価額が著しく低下し、回復の見込みがないと判断される場合に評価減を検討します。単に「最近相場が下がっている」というだけでは会計上の評価減の要件を満たしません。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='税務上の判定基準：損金算入できるケースは限定的' fontWeight={700} />
                <p>
                    会計上は評価損を計上できても、税務上は損金として認められる（法人税の課税所得を減らせる）ケースがかなり限定されている点が、ゴルフ会員権特有の注意点です。
                </p>

                <Heading3 title='株式形態の会員権（有価証券）' />
                <p>
                    税務上、評価損の損金算入が認められるのは、発行会社の資産状態が著しく悪化したため会員権の価額が著しく低下した場合に限られます。具体的には、特別清算の開始決定など法的な事実が生じた場合、または期末時点の1株（1口）あたりの純資産価額が取得時のおおむね50％以上下落した場合が対象です。
                </p>

                <Heading3 title='預託金形態の会員権' />
                <p>
                    預託金形態の会員権は、単純な保証金（金銭債権）としての性質を持つため、原則として評価損の計上は認められません。損金算入が可能になるのは、発行会社が更生手続・再生手続・特別清算・破産手続などの法的整理に入り、預託金の一部または全部の切り捨てが法的に確定した場合（貸倒損失）、あるいは法的整理の申立てがされ施設利用権（プレー権）が消滅した場合（貸倒引当金）に限られます。ケースごとの詳しい要件は税理士にご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='判定の際に確認すべきポイント' fontWeight={700} />
                <p>
                    評価損の計上を検討する際は、少なくとも以下の点を確認しましょう。
                    <br />
                    <br />
                    ・その会員権に取引相場があるかどうか
                    <br />
                    ・会員権の形態が株式（出資）か預託金かどちらか
                    <br />
                    ・発行会社について特別清算・破産・民事再生・更生手続などの法的な事実が生じているか
                    <br />
                    ・株式形態の場合、期末の1株（1口）あたり純資産価額が取得時からおおむね50％以上下落しているか
                    <br />
                    ・単なる相場下落なのか、発行会社の財政状態の悪化にともなうものなのか
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='会計上と税務上で処理がズレる場合の注意点' fontWeight={700} />
                <p>
                    会計上は保守的に評価損を計上したものの、税務上の要件（発行会社の資産状態の著しい悪化など）を満たしていない場合、その評価損は損金として認められません。この場合、法人税の申告調整（別表四での加算）が必要になり、会計上の利益と税務上の課税所得にズレが生じます。
                    <br />
                    評価損を計上する際は、会計処理と税務処理を分けて検討し、税務上の要件を満たしていない評価損については申告調整を忘れないようにしましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    ゴルフ会員権の評価損は、会計上は時価の有無、税務上は発行会社の財政状態の悪化度合いという、それぞれ異なる基準で判定します。特に税務上は要件が厳格なため、相場が下がっているというだけで安易に損金算入できるものではありません。
                    <br />
                    具体的な計上方法や貸倒処理の要件は<a href='/knowledge/10'>こちら</a>
                    で解説していますので、あわせてご確認のうえ、判断に迷う場合は税理士にご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge37;
